import { getEventTarget, isNullOrEmpty, queryDocument, trackEvent } from "../../../utils";
import { constants } from "../common";
import { EventEmitter } from "../../../utils";
import { events } from "../../../scripts/constants";

const { basketIndicator } = constants.selectors;

const settings = {
  BASKET_INDICATOR_COUNT: "data-basket-indicator-count",
  BASKET_INDICATOR_TOTAL: "data-basket-indicator-total",
  CLASS_ICON_HIDDEN: "nav-icon--hidden",
};

const basketIndicatorElements = queryDocument<HTMLAnchorElement>(basketIndicator);

export function updateBasketBar({ totalItems, total, checkoutUrl }: BasketBarOptions) {
  if (!basketIndicatorElements || basketIndicator.length == 0) {
    console.warn("Basket bar not supported on current page.");
    return;
  }

  basketIndicatorElements.forEach((basketIndicatorElement) => {
    var showBasketIndicator = false;
    if (!isNullOrEmpty(total)) {
      basketIndicatorElement.setAttribute(settings.BASKET_INDICATOR_TOTAL, total);
      showBasketIndicator = true;
    }

    if (!isNullOrEmpty(totalItems)) {
      basketIndicatorElement.setAttribute(settings.BASKET_INDICATOR_COUNT, totalItems);
      showBasketIndicator = true;
    }

    if (!isNullOrEmpty(checkoutUrl)) {
      basketIndicatorElement.href = checkoutUrl;
      showBasketIndicator = true;
    }

    if (showBasketIndicator) {
      basketIndicatorElement.classList.remove(settings.CLASS_ICON_HIDDEN);
    } else {
      basketIndicatorElement.classList.add(settings.CLASS_ICON_HIDDEN);
    }

    basketIndicatorElement.addEventListener("click", trackCheckoutClick);
  });
}

EventEmitter.on(events.UPDATE_BASKET_BAR, (props: BasketBarOptions) => {
  updateBasketBar(props);
});

function trackCheckoutClick(e) {
  var target = getEventTarget(e);
  var basketTotal = target.getAttribute(settings.BASKET_INDICATOR_TOTAL);

  if (basketTotal && Number(basketTotal) > 0)
    trackEvent({
      event: "basket-activity",
      category: "Basket Activity",
      action: "Checkout",
      label: basketTotal,
    });
}

export type BasketBarOptions = {
  totalItems?: string;
  total?: string;
  checkoutUrl?: string;
};
